<template>
  <section class="bg-light">
    <div class="container bg-light">
      <div class="row">
        <div class="col-lg-6 mb-4 sticky-lg-top">
          <div class="mb-5">
            <h4>#1 Open P.O oleh-oleh express khas Bali</h4>
            <div>
              <p>Harap Melakukan Transfer Rp 300,000 ke Rekening BCA 1234-1345-123 a/n Pipit Agustin</p>
            </div>
          </div>
          <div class="mb-5">
            <h4>#1 Open P.O oleh-oleh express khas Bali</h4>
            <div>
              <p>Harap Melakukan Transfer Rp 300,000 ke Rekening BCA 1234-1345-123 a/n Pipit Agustin</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-5 col-md-9 aos-init aos-animate">
          <div class="card card-body shadow-lg">
            <div class="form-group">
              <label for="planner-name">Name</label>
              <input
                type="text"
                name="contact-name"
                class="form-control"
                id="planner-name"
                required
                style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4EaVTO26DQBD1ohQWaS2lg9JybZ+AK7hNwx2oIoVf4UPQ0Lj1FdKktevIpel8AKNUkDcWMxpgSaIEaTVv3sx7uztiTdu2s/98DywOw3Dued4Who/M2aIx5lZV1aEsy0+qiwHELyi+Ytl0PQ69SxAxkWIA4RMRTdNsKE59juMcuZd6xIAFeZ6fGCdJ8kY4y7KAuTRNGd7jyEBXsdOPE3a0QGPsniOnnYMO67LgSQN9T41F2QGrQRRFCwyzoIF2qyBuKKbcOgPXdVeY9rMWgNsjf9ccYesJhk3f5dYT1HX9gR0LLQR30TnjkUEcx2uIuS4RnI+aj6sJR0AM8AaumPaM/rRehyWhXqbFAA9kh3/8/NvHxAYGAsZ/il8IalkCLBfNVAAAAABJRU5ErkJggg==&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;"
              />
              <div class="invalid-feedback">Please type your name.</div>
            </div>
            <div class="form-group">
              <label for="planner-email">Email Address</label>
              <input
                type="email"
                name="contact-email"
                class="form-control"
                id="planner-email"
                placeholder="you@website.com"
                required
              />
              <div class="invalid-feedback">Please provide your email address.</div>
            </div>
            <div class="form-group">
              <label for="planner-phone">Phone (optional)</label>
              <input
                type="tel"
                name="contact-phone"
                class="form-control"
                id="planner-phone"
                required
              />
              <div class="invalid-feedback">Please provide your phone number.</div>
            </div>
            <div class="form-group">
              <label for="planner-message">Alamat Pengiriman</label>
              <textarea name="message" id="planner-message" rows="3" class="form-control" required></textarea>
              <div class="invalid-feedback">Please tell us a bit more about your requirements.</div>
            </div>

            <router-link to="/orderconfirmation" class="btn btn-primary order-lg-3" tag="a"> Kirim </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Address"
};
</script>